import { render, staticRenderFns } from "./ReviewOrderFilter.vue?vue&type=template&id=2b553716"
import script from "./ReviewOrderFilter.vue?vue&type=script&lang=js"
export * from "./ReviewOrderFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports